"use client";

import { Baby, Sprout, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Culinaryphilosophy() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const features = [{
    icon: Sprout,
    label: "Repas adaptés au post-partum"
  }, {
    icon: Baby,
    label: "Ingrédients de saison"
  }, {
    icon: Users,
    label: "Pour toute la famille"
  }];
  return <section data-section-id="85" id="culinaryphilosophy" className="bg-background text-foreground relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[720px]">
        {}
        <div ref={imageRef} className={`relative overflow-hidden h-[400px] sm:h-[500px] lg:h-auto transition-all duration-1000 ease-out ${imageVisible ? "opacity-100" : "opacity-0"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/postnatal_care_nurturing.webp" alt="Accompagnement bienveillant et doux pour une maman et son nouveau-né" loading="lazy" decoding="async" className={`w-full h-full object-cover transition-transform duration-[2000ms] ease-out ${imageVisible ? "scale-100 translate-y-0" : "scale-105 translate-y-4"}`} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/607ece8bdd446a6876edddc81768006b.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0.png" src="https://quality-chicken.10web.cloud/wp-content/uploads/2026/06/eacd27eb-2be8-464f-8496-d1f746a6b02f.png" src="https://quality-chicken.10web.cloud/wp-content/uploads/2026/06/cf87ac52-f3dc-4331-990e-94b36c83def4.png" />
          {}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: "radial-gradient(ellipse at center, transparent 40%, hsla(30, 25%, 92%, 0.45) 100%)"
        }} />
          {}
          <div className="absolute inset-0 pointer-events-none bg-primary/5 mix-blend-overlay" />
        </div>

        {}
        <div ref={textRef} className="relative flex items-center justify-center px-6 sm:px-10 lg:px-16 xl:px-24 py-16 lg:py-24" style={{
        backgroundColor: "#F8F4ED",
        color: "#43362F"
      }}>
          <div className={`max-w-xl w-full transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="block h-px w-8" style={{
              backgroundColor: "#A77B62"
            }} />
              <span className="font-default text-xs tracking-[0.25em] uppercase" style={{
              color: "#A77B62"
            }}>SLOW MAMA</span>
            </div>

            {}
            <h2 className="font-light text-4xl leading-[1.05] tracking-tight mb-8 !font-serif sm:text-5xl lg:text-6xl"><span className="!font-sans"><span className="!font-serif">C'est quoi le batch cooking?</span></span></h2>

            {}
            <p className="font-default text-base sm:text-lg leading-relaxed mb-10 max-w-md" style={{
            color: "#43362F"
          }}>Le batch cooking consiste à préparer en une seule séance plusieurs repas à conserver au réfrigérateur ou au congélateur pour les jours suivants. Je cuisine directement chez toi des plats nourrissants, adaptés à tes besoins en post-partum, pour te permettre de récupérer et de profiter pleinement de ton bébé.</p>

            {}
            <div className="flex items-start justify-between sm:justify-start sm:gap-12 mb-10 pb-10 border-b" style={{
            borderColor: "#D5C3B1"
          }}>
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <div key={feature.label} data-index={i} className="flex flex-col items-center sm:items-start gap-3">
                    <Icon className="w-6 h-6" strokeWidth={1} style={{
                  color: "#A77B62"
                }} />
                    <span className="font-default text-[10px] sm:text-xs tracking-[0.2em] uppercase text-center sm:text-left" style={{
                  color: "#43362F"
                }}>
                      {feature.label}
                    </span>
                  </div>;
            })}
            </div>

            {}
            <Button asChild variant="link" className="p-0 h-auto font-default text-sm tracking-wider uppercase hover:no-underline group" style={{
            color: "#A77B62"
          }}>
              <Link className="border-b pb-1 transition-all duration-300 group-hover:border-b-2 underline cursor-pointer" to="/ContactPage">
                <span style={{
                borderColor: "#A77B62"
              }}>me contacter</span>
                <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">
                  &rarr;
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}